var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "font-select"
  }, [!_vm.showPasteInput ? _c('v-select', {
    attrs: {
      "value": _vm.value,
      "items": _vm.items,
      "item-text": "family",
      "item-value": "family",
      "hide-details": "",
      "solo": ""
    },
    on: {
      "change": _vm.onFontSelect
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [item.divider ? _c('v-divider') : _c('span', {
          style: _vm.itemStyle(item)
        }, [_vm._v(_vm._s(item.family))])];
      }
    }, {
      key: "selection",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('span', {
          style: _vm.itemStyle(item)
        }, [_vm._v(_vm._s(item.family))])];
      }
    }], null, false, 2663608165)
  }) : _vm._e(), _vm.showPasteInput ? _c('div', {
    staticClass: "paste-inline"
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": _vm.$t('design_font_paste_placeholder'),
      "solo": "",
      "hide-details": "",
      "autofocus": ""
    },
    on: {
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.applyPaste.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancelPaste.apply(null, arguments);
      }]
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c('v-btn', {
          attrs: {
            "icon": "",
            "title": _vm.$t('save'),
            "loading": _vm.loading
          },
          on: {
            "click": _vm.applyPaste
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("mdi-check")])], 1), _c('v-btn', {
          attrs: {
            "icon": "",
            "title": _vm.$t('cancel'),
            "disabled": _vm.loading
          },
          on: {
            "click": _vm.cancelPaste
          }
        }, [_c('v-icon', [_vm._v("mdi-close")])], 1)];
      },
      proxy: true
    }], null, false, 656663257),
    model: {
      value: _vm.pasteInput,
      callback: function callback($$v) {
        _vm.pasteInput = $$v;
      },
      expression: "pasteInput"
    }
  }), _vm.pasteError ? _c('div', {
    staticClass: "paste-error mt-1"
  }, [_vm._v(" " + _vm._s(_vm.pasteError) + " ")]) : _vm._e()], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }